<template>
  <div class="mb-6 py-8">
    <!-- Formulário de recuperação de senha -->
    <form @submit.prevent="handlePasswordRecovery" class="mb-6 py-8">
      <div>
        <label for="email" class="block text-gray-700 text-sm font-medium mb-2"
          >E-mail</label
        >
        <input
          v-model="email"
          type="email"
          id="email"
          class="w-full p-4 bg-gray-200 rounded-lg focus:ring-2 focus:ring-blue-400"
          placeholder="Digite seu e-mail"
          required
          aria-label="E-mail"
        />
      </div>

      <button
        type="submit"
        class="w-full mt-4 bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-lg transition flex items-center justify-center gap-2"
        :disabled="loading"
      >
        <svg
          v-if="loading"
          class="animate-spin h-5 w-5 text-white"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M12 2a10 10 0 0110 10h-4a6 6 0 00-6-6V2z"
          ></path>
        </svg>
        <span>{{ loading ? 'Enviando...' : 'Enviar' }}</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'PasswordRecovery',
  data() {
    return {
      email: '',
      loading: false,
      errorMessage: '',
    }
  },
  methods: {
    async handlePasswordRecovery() {
      this.loading = true
      this.errorMessage = ''

      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailPattern.test(this.email)) {
        this.errorMessage = 'Por favor insira um e-mail válido.'
        this.loading = false
        return
      }

      try {
        // Simulação de envio de email
        await new Promise((resolve) => setTimeout(resolve, 1000))
        this.$router.push('/')
      } catch (error) {
        this.errorMessage = 'Falha ao enviar a recuperação. Tente novamente.'
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
button:active {
  transform: scale(0.98);
}
</style>
